// extracted by mini-css-extract-plugin
export default {"actionButtonsWrapper":"ActionButtons_actionButtonsWrapper__cXraP","saveButton":"ActionButtons_saveButton__-bJxH","cancelButton":"ActionButtons_cancelButton__hXBQQ"};